module.exports = __webpack_public_path__ + "img/test.aa7c535d.jpg";